export default [
    {
        id: 1,
        name: 'all'
    },
    {
        id: 2,
        name: 'conferences'
    },
    {
        id: 3,
        name: 'projects'
    },
    {
        id: 4,
        name: 'publications'
    },
    {
        id: 5,
        name: 'events'
    },
    {
        id: 6,
        name: 'from-life'
    },
];



// WEBPACK FOOTER //
// ./src/scripts/NewsSubpages.js